import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Grid, GridColumn, List, ListItem, Readmore, Separator, Text } from 'telia-front-react';
import { Programme } from '../../stores/GuideStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import LanguageStore from '../../stores/LanguageStore';

interface ChannelProgrammeProps {
  programme: Programme;
  line: boolean;
  first: boolean;
  descriptionMaxLength?: number;
  languageStore?: LanguageStore;
}

@observer
class ChannelProgramme extends React.Component<ChannelProgrammeProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private renderSeasonAndEpisode() {
    const translate = this.context.translate;
    const { season, episode, originalTitle } = this.props.programme;

    if (!season && !episode && !originalTitle) {
      return null;
    }
    const seasonLabel = season ? `${translate('tv.guide.season')} ${season}` : '';
    const episodeLabel = episode ? `${translate('tv.guide.episode')} ${episode}` : '';
    const seasonAndEpisodeLabel = `${seasonLabel}${seasonLabel && episodeLabel ? ' / ' : ''}${episodeLabel}`;
    return (
      <List className="text-light text__margin-half" direction="inline" bordered={true} type="unstyled">
        {originalTitle && <ListItem>{originalTitle}</ListItem>}
        {seasonAndEpisodeLabel && <ListItem>{seasonAndEpisodeLabel}</ListItem>}
      </List>
    );
  }

  private renderDescriptionAndButton() {
    const translate = this.context.translate;
    const {
      programme: { description, id },
      first,
      descriptionMaxLength,
      languageStore: { currentLanguage }
    } = this.props;
    const url = `https://www.teliatv.ee${currentLanguage !== 'et' ? `/${currentLanguage}` : ''}/saade/${id}`;

    return first ? (
      <>
        {description &&
          (descriptionMaxLength ? (
            <Readmore
              text={description}
              charsToShow={descriptionMaxLength}
              moreText={translate('tv.guide.description.readMore')}
              lessText={translate('tv.guide.description.showLess')}
            />
          ) : (
            <p>{description}</p>
          ))}
        <AnalyticsTrigger trigger={{ id: 'Link - Vaatan saadet', callback: 'onClick' }}>
          <Button url={url} target="_blank" text={translate('tv.guide.watchShow')} iconRight="#arrow-right" className="text__margin-double" />
        </AnalyticsTrigger>
      </>
    ) : null;
  }

  public render() {
    const {
      programme: { time, title },
      line
    } = this.props;

    return (
      <>
        <Grid horizontalGutter="none">
          <GridColumn width={['xs-3', 'sm-2']}>
            <p className="h5">{time}</p>
          </GridColumn>
          <GridColumn width={['xs-9', 'sm-10']}>
            <Text>
              <p className="h5">{title}</p>
              {this.renderSeasonAndEpisode()}
              {this.renderDescriptionAndButton()}
            </Text>
          </GridColumn>
        </Grid>
        {line && <Separator spacing="small" weight="thin" />}
      </>
    );
  }
}

export default inject('languageStore')(ChannelProgramme);
